// Year specific values shown to candidates in declarations, eligibility notes and
// internship date inputs. Keep the year values here so the next admission session
// only needs this file updated.

export const CURRENT_SESSION = '2026-27'
export const CURRENT_SESSION_LONG = '2026-2027'

// Govt. of Haryana notification date quoted in the candidate declarations.
const NOTIFICATION_DATES = {
  MD: '3rd November, 2026',
  MDS: '8th September, 2026',
  PGDNB: '3rd September, 2026',
}

// MD and MDS have different internship cut-off dates, so each counselling keeps
// its own value used both for the note text and for the date input max.
const INTERNSHIP_CUT_OFF_DATES = {
  MD: '2026-07-31',
  MDS: '2026-05-31',
}

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const getOrdinalDay = (day) => {
  const lastTwoDigits = day % 100
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${day}th`

  switch (day % 10) {
    case 1:
      return `${day}st`
    case 2:
      return `${day}nd`
    case 3:
      return `${day}rd`
    default:
      return `${day}th`
  }
}

// Display labels used across the registration flow: the home page buttons set the
// short code on the global stream and the instruction page replaces it with the label.
export const COUNSELLING_DISPLAY_NAMES = {
  MD: 'MD/MS/Post MBBS Diploma/Post MBBS DNB',
  MDS: 'MDS',
  PGDNB: 'Post Diploma DNB',
}

// Accepts either the short code (MD / MDS / PGDNB) or the display label and returns
// the short code, so both forms found in the global stream resolve to the same key.
export const getCounsellingCode = (counsellingName) => {
  if (!counsellingName) return ''

  const name = String(counsellingName).trim().toUpperCase()
  const exactMatch = Object.keys(COUNSELLING_DISPLAY_NAMES).find(
    (code) => code === name || COUNSELLING_DISPLAY_NAMES[code].toUpperCase() === name,
  )
  if (exactMatch) return exactMatch

  if (name.includes('MDS')) return 'MDS'
  if (name.includes('DNB')) return 'PGDNB'
  if (name.includes('MD')) return 'MD'
  return ''
}

export const getNotificationDate = (counsellingName) =>
  NOTIFICATION_DATES[getCounsellingCode(counsellingName)] || ''

export const getInternshipCutOffDate = (counsellingName) =>
  INTERNSHIP_CUT_OFF_DATES[getCounsellingCode(counsellingName)] || ''

export const getInternshipCutOffText = (counsellingName) => {
  const cutOffDate = getInternshipCutOffDate(counsellingName)
  if (!cutOffDate) return ''

  const [year, month, day] = cutOffDate.split('-').map(Number)

  return `The cut-off date for completion of internship is ${getOrdinalDay(day)} ${MONTH_NAMES[month - 1]}, ${year}.`
}
